import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { interval, Subscription, takeWhile } from 'rxjs';

@Component({
    selector: 'cp-idle-modal',
    imports: [WdxIconModule],
    templateUrl: './idle-modal.component.html',
    styleUrls: ['./idle-modal.component.scss'],
})
export class IdleModalComponent implements OnInit, OnDestroy {
    public activeModal = inject(NgbActiveModal);

    @Input() seconds!: number;

    subscription = new Subscription();

    ngOnInit(): void {
        const source = interval(1000);
        this.subscription = source
            .pipe(takeWhile(() => this.seconds > 0))
            .subscribe(() => (this.seconds = this.seconds - 1));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public stayLoggedIn() {
        this.activeModal.close(true);
    }
}
